import type React from 'react';
import { useEffect } from 'react';

import { debounce, throttle } from 'lodash';

import { usePageNavigation } from 'bundles/unified-description-page-common/contexts/PageNavigationContext';

const useUpdateCtaPosition = (pageCtaRef: React.RefObject<HTMLDivElement>) => {
  const { updatePageCtaPosition } = usePageNavigation();

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const updateCtaPositionThrottle = throttle(() => {
      const bottom = pageCtaRef?.current?.getBoundingClientRect().bottom;
      if (bottom !== undefined) {
        updatePageCtaPosition?.(bottom);
      }
    }, 100);

    const updateCtaPositionDebounce = debounce(
      () => {
        const bottom = pageCtaRef?.current?.getBoundingClientRect().bottom;
        if (bottom !== undefined) {
          updatePageCtaPosition?.(bottom);
        }
      },
      300,
      { trailing: true }
    );

    const updateCtaPosition = () => {
      updateCtaPositionThrottle();
      updateCtaPositionDebounce();
    };

    updateCtaPosition();

    window.addEventListener('scroll', updateCtaPosition);
    window.addEventListener('resize', updateCtaPosition);

    return () => {
      window.removeEventListener('scroll', updateCtaPosition);
      window.removeEventListener('resize', updateCtaPosition);
    };
  }, [pageCtaRef, updatePageCtaPosition]);
};

export default useUpdateCtaPosition;
